export default {
  fastRegistration: 'Schnelle Registrierung',
  userEnter: 'Login für Kunden',
  contacts: 'Kontakte',
  findOutTheCost: 'Ein Angebot erhalten',
  brand: 'SOVTES',
  register: 'Registrieren',
  metaTags: {
    metaTitle:
      'Sovtes - Online-Logistik, Frachtmanagement, eTTN, eCMR, Webprogramm',
    metaDecription:
      'Sovtes ist ein webbasiertes Frachtkontrollprogramm. ermöglicht es Ihnen, Fracht durch die Automatisierung von Logistikprozessen effektiv zu verwalten. Registrierung des elektronischen Frachtbriefs, ettn, ecmr',
    metaKeywords:
      'Fracht, freie Strecken für Spediteure, Online-Logistik, Programm-Sowjets, Sowjets, ettn, ecmr',
    ttnDescription:
      'Ermöglicht die kostenlose Online-Registrierung eines elektronischen Frachtbriefs mit digitaler Signatur in der Ukraine, add ecmr',
    ttnKeywords:
      'TTN-Registrierung kostenlos online, eTTN, elektronischer Frachtbrief mit digitaler Signatur, Programm Sovtes, Sovtes, ecmr',
    ttnTitle:
      'TTN-Registrierung kostenlos online in der Ukraine, eTTN, eCMR - Sovtes',
    thankyouTitle: 'Danke - Sovtes',
    thankyou2Title: 'Danke - Sovtes',
    thankyou3Title: 'Danke - Sovtes',
    thankyou4Title: 'Danke - Sovtes',
    thankyou5Title: 'Danke - Sovtes',
    thankyou6Title: 'Danke - Sovtes',
  },
  nav: {
    links: {
      1: 'Produkt',
      5: 'Preisaudit',
      2: 'Für Frachtführer',
      3: 'Für Versender',
      4: 'Preis',
    },
  },
  sectionMain: {
    msg1: 'bis zu 25% reale Einsparungen',
    msg2: 'auf LKW',
    registration: 'Registrieren',
    knowMore: 'Mehr über das Produkt erfahren',
    thankyou1: 'Danke! Wir werden Sie in Kürze kontaktieren',
    thankyou2: 'Danke! Wir werden Sie in Kürze kontaktieren',
    thankyou3: 'Danke! Wir werden Sie in Kürze kontaktieren',
    thankyou4: 'Danke! Wir werden Sie in Kürze kontaktieren',
    thankyou5: 'Danke! Wir werden Sie in Kürze kontaktieren',
    thankyou6: 'Danke! Wir werden Sie in Kürze kontaktieren',
    ettn1: 'Danke, dass Sie eCMR unterschrieben haben.',
    ettn2:
      'Klicken Sie unten auf die blaue Schaltfläche "ETTN signiert", um fortzufahren',
    ttn1:
      'Kostenlose Registrierung von eCMR: elektronisches CMR in der Ukraine',
    ttn2: 'Registrieren und wir verbinden Sie mit eCMR',
  },
  sectionSlogan: {
    msg1: 'Ihr primäres LKW-Logistik-Managementsystem',
    msg2: 'ist eine SAAS-Lösung für ein profitables Frachtmanagement',
  },
  sectionPositions: {
    list: {
      1: 'Einfachheit',
      2: 'Effizienz',
      3: 'Verfügbarkeit',
    },
    msg1:
      'Erfahren Sie, wie man Logistikprobleme eines Unternehmens, das Mietfahrzeuge zur Lieferung von Waren verwendet, lösen kann. Wir senden Ihnen eine kostenlose Präsentation per E-Mail zu, die von unseren Experten entwickelt wurde',
  },
  sectionAudit: {
    title: 'AUDIT der Beförderungspreise',
    footer: {
      txt1: 'Sovtes LLC ist einer von',
      link:
        'Sovtes GmbH ist einer der 7 zugelassenen Lieferanten des elektronischen Frachtbriefs der Ukraine.',
      txt2:
        'Verbinden Sie sich mit dem zentralen ETNN-Register mit einem zugelassenen Lieferanten SOVTES',
    },
  },
  sectionAdvantages: {
    title: 'Vorteile',
    shipper: 'FÜR VERSENDER',
    transporter: 'FÜR FRACHTFÜHRER',
    lists: {
      transporter: {
        11: {
          label: 'Aktuelle Bestellungen',
          description:
            'Sovtes kooperiert ausschließlich mit Direktkunden und schließt die Möglichkeiten der Duplizierung von Frachtaufträgen aus.',
        },
        12: {
          label: 'Attraktive Partnerschaft',
          description:
            'Als Partner von Sovtes erhalten Sie einen Zugang zu allen Aufträgen unserer Kunden. Dabei sind zusätzliche Vertragsabschlüsse nicht notwendig.',
        },
        13: {
          label: 'Schnelle Aufträge',
          description:
            'Ein Auftrag bei Sovtes enthält alle notwendigen Transportdaten. Es genügt ein Fahrzeug anzubieten und einen Antrag zu unterzeichnen, der automatisch erstellt wird. Keine Anrufe sind erforderlich.',
        },
        14: {
          label: 'Schnelle Bezahlung',
          description:
            'Wenn Sie einen Auftrag über Sovtes durchführen, erhalten Sie garantiert Ihre Zahlung innerhalb von 10 Werktagen nach dem Entladen der Ware.',
        },
        15: {
          label: 'Neue Auftraggeber',
          description:
            'Wir arbeiten ständig daran, um neue Auftraggeber von Transportdienstleistungen zu gewinnen. Sie wählen, mit wem und unter welchen Bedingungen Sie arbeiten.',
        },
        16: {
          label: 'Senken Sie Ihre Kosten',
          description:
            'Leerläuf- und Leerfahren senken Ihren Einkommen. Über uns können Sie einen unbegrenzten Zugang zu allen aktuellen Aufträgen erhalten und so Ihre Kosten, die durch Leerläuffahrten entsehen, reduzieren.',
        },
      },
      shipper: {
        21: {
          label: 'Schneller Start',
          description:
            'Vollständige Systeminbetriebnahme unserer Software in Ihrem Unternehmen erfolgt in weniger als 5 Tagen.',
        },
        22: {
          label: 'Einsparung',
          description:
            'Das SOVTES-System reduziert die Transportkosten garantiert um 22-25%.',
        },
        23: {
          label: 'Berichterstattung',
          description:
            'Automatische zeitnahe und zuverlässige Berichte über Ihre Transaktionen.',
        },
        24: {
          label: 'Schnelligkeit',
          description:
            'Die Suche nach dem richtigen Transport erfolgt in wenigen Minuten.',
        },
        25: {
          label: 'Elektronischer Dokumentendurchlauf',
          description:
            'Vereinfacht und beschleunigt Ihre Arbeit mit den Frachtführern.',
        },
        26: {
          label: 'Integration',
          description:
            'Automatisierter Datenaustausch mit verschiedenen ERP-Systemen Ihres Unternehmens.',
        },
      },
    },
  },
  partners: {
    title: 'Partner',
    subTitle: 'Nur für Sovtes-Clients:',
    list: {
      1: {
        description:
          'Erste zwei Monate der Nutzung des Dienstes "Vchasno" sind kostenlos',
      },
      2: {
        description:
          'Mitbegründer von Sovtes Oleh Rudkovsky ist Vorsitzender des Ausschusses für Verkehr und Logistik der SUP (Union der ukrainischen Unternehmer)',
      },
    },
  },
  clientsSection: {
    title: 'Kunden',
    list: {
      1: {
        name: 'Alexey Nod',
        rank: 'Leiter der Transportlogistikabteilung des MCHP JSC',
        comment:
          'Wir arbeiten seit 2014 mit dem Team zusammen. Wir möchten Sovtes unseren Dank dafür aussprechen, dass sie ein effektives, sich ständig weiterentwickelndes Produkt geschaffen haben! Dank Ihres Portals haben wir neue Geschäftspartner gewonnen, die Zeit für die Bearbeitung von Anfragen deutlich reduziert und den Transport mit konstanter Auslastung sichergestellt. Wir wünschen Ihnen weiterhin ein gutes Gelingen des Projekts! Nur vorwärts!',
      },
      2: {
        name: 'Anna Khvatova',
        rank: 'Leiter der Abteilung Transport Logistics LLC TD Schedro',
        comment:
          'Einer der Hauptvorteile ist die Möglichkeit, volle Transparenz des Ausschreibungsverfahrens zu organisieren, sowie Geld und Zeit für die Lösung von Aufgaben zu sparen. Für unser Unternehmen ist die Implementierung des Systems zu einer der effektivsten Methoden geworden, um fairen Wettbewerb und Transparenz bei der Beschaffung von Transportdienstleistungen zu gewährleisten.',
      },
      3: {
        name: 'Lilia KUSHNARYOVA',
        rank:
          'Direktor der Verwaltungs- und Logistikabteilung von Global Spirits (TM Khortytsia)',
        comment:
          'Wir arbeiten seit über einem Jahr mit SOVTES zusammen. Es ist ein multifunktionales Informationsprogramm, das uns Zeit und Geld spart. Mit SOVTES sind Sie und Ihre Spediteure immer im Besitz von aktuellen Informationen. Die SOVTES-Plattform zeichnet sich durch einfache Bedienung und zuverlässige Informationsspeicherung aus. Wir empfehlen die Zusammenarbeit!',
      },
    },
  },
  howItWorks: {
    title: 'wie es funktioniert',
    list: {
      1: {
        label: 'Berichterstattung',
        description:
          'Die Liste der gespeicherten Daten ermöglicht es uns, die erforderlichen Berichte gemäß den Anforderungen unserer Kunden zu erstellen. Auf Wunsch des Kunden entwickeln wir personalisierte Berichte, die vom System automatisch erstellt und an die entsprechende Person gesendet werden.',
      },
      2: {
        label: 'Dokumentenfluss',
        description:
          'Der elektronische Dokumentenfluss und die automatische Dokumentenerstellung erhöhen das Sicherheitsniveau erheblich und das Risiko des Datenverlusts wird eliminiert. Außerdem werden dadurch die Korrespondenzkosten um bis zu 99% gesenkt und der Dokumentenaustausch wird auf nur wenige Minuten beschleunigt.',
      },
      3: {
        label: 'Einfache Interaktion',
        description:
          'Nach der Veröffentlichung des Auftrags erhalten alle Spediteure sofort und gleichzeitig Informationen über die Bestellung. Über die SOVTES - Software können Kunden und Spediteure ganz einfach und unkompliziert Daten miteinander tauschen und sich auf einen Transportauftrag einigen.',
      },
      4: {
        label: 'Leistungserfassung ',
        description:
          'Alle Transaktionen und wichtigen Kennzahlen werden in sicheren Datenbanken gespeichert. Die Möglichkeit der Integration über die API ermöglicht die Übertragung der erforderlichen Informationen an die ERP-Systeme unserer Kunden. Die Speicherung und Übertragung von Daten erfolgt vollständig automatisiert und erfordert keine Humanressourcen.',
      },
    },
  },
  aboutSection: {
    subTitle:
      'SOVTES ist ein Service, der es Ihnen ermöglicht, die Zustellung von Gütern in allen Phasen des Transports zu überwachen, aktuelle Statistiken über Ihre Sendungen zu erhalten und mit der Dokumentation zu arbeiten.',
  },
  sectionPrice: {
    title1: 'Preis für Versender',
    msg1: 'hängt von der Anzahl der Sendungen ab, die Sie pro Monat tätigen.',
  },
  forms: {
    shipper: 'Ich bin Versender',
    transporter: 'Ich bin Frachtführer',
  },
  footer: {
    msg1: 'eCMR online registrieren',
    address: {
      city: '04112, Kiew,',
      street: 'st. Dorogozhytska 3',
      house: 'Unit City, В9, Office 414',
    },
  },
}
